import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor() { }

  public cardData = [
    {
      title: 'Review Ecosystem',
      icon: 'ion-ios-chatboxes-outline',
      description: 'A centralized platform where students can regularly review professors’ teaching methodologies and professors can review students’ learning approaches so both can improve for better outcomes.'
    },
    {
      title: 'AI Moderator',
      icon: 'ion-ios-color-wand-outline',
      description: 'Our versatile AI moderator moderates the reviews to ensure they follow stipulated community guidelines, are consistent with university policies, and that they are true.'
    },
    {
      title: 'Real-time recommendations',
      icon: 'ion-ios-person-outline',
      description: 'Provides professors with comprehensive and actionable real-time recommendations for the specific lecture, topic, and course that is the subject of student reviews.'
    },
    {
      title: 'Interactive Reports and dashboards',
      icon: 'ion-ios-speedometer-outline',
      description: 'Stakeholders can easily monitor the learning experience and observe educational performance. Different reports can also be generated after analysis of student reviews by the software.'
    }
  ];

  ngOnInit() {
  }

}
